export const authKeys = {
  user: 'user',
  custom: 'custom',
  customData: '@customData',
  accessToken: 'accessToken',
  menuVersions: 'menuVersions',
  menuDatakey: 'menu-data-object',
  videoPlaybackRate: 'video-playbackrate',
  authToken: 'next.auth.token',
  authRefreshToken: 'next.auth.refreshToken',
  popupGreetings: 'popup-greetings',
  authIdentifier: 'next.auth.identifierAuth',
  authCustomer: 'next.auth.customer',
};
